var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-1 bg-grey-200"})
}
var staticRenderFns = []

export { render, staticRenderFns }